import { render, staticRenderFns } from "./LoaderSmall.vue?vue&type=template&id=6acb0719&"
import script from "./LoaderSmall.vue?vue&type=script&lang=js&"
export * from "./LoaderSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports